module.exports = __webpack_public_path__ + "static/media/image12-example.00c8acc0.jpg";